module.exports = __webpack_public_path__ + "img/connect-empty.4dd095de.png";